import { MainWithSkipLink } from '@amzn/stencil-react-components/a11y';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { PageContainer } from '@amzn/stencil-react-components/page';
import React from 'react';
import AppRoutes from 'src/AppRoutes';
import Authentication from 'src/components/Authentication';
import NavigationBar from 'src/components/NavigationBar';
const App = () => {
  return (
    <StencilProvider>
      <Authentication>
        <NavigationBar />
        <MainWithSkipLink>
          <PageContainer isFullWidth={true}>
            <AppRoutes />
          </PageContainer>
        </MainWithSkipLink>
      </Authentication>
    </StencilProvider>
  );
};
export default App;
